// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.aButton[data-v-221294dc] {\r\n  width: 200px;\r\n  color: white;\n}\r\n", ""]);
// Exports
module.exports = exports;
